import { render, staticRenderFns } from "./PaymentMethodHeader.vue?vue&type=template&id=f1d15efc&scoped=true"
import script from "./PaymentMethodHeader.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodHeader.vue?vue&type=script&lang=ts"
import style0 from "./PaymentMethodHeader.vue?vue&type=style&index=0&id=f1d15efc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d15efc",
  null
  
)

export default component.exports